import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import {
  CaseBattlesSlotsVariants,
  ICaseBattle,
  ICaseBattlePlayer,
} from '../interfaces/case-battles.interface';
import { SessionService } from '@core/services/session.service';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { Engine, ISourceOptions } from '@tsparticles/engine';
import { NgParticlesService, NgxParticlesModule } from '@tsparticles/angular';
import { loadSlim } from '@tsparticles/slim';
import { CaseBattlesService } from '../case-battles.service';
import { CostComponent } from '../../../core/components/cost/cost.component';
import { BalanceType } from '@core/types/balance.type';

@Component({
  selector: 'app-cb-battle-middle-waiting-player',
  imports: [GameIconComponent, NgxParticlesModule, CostComponent],
  templateUrl: './cb-battle-middle-waiting-player.component.html',
  styleUrl: './cb-battle-middle-waiting-player.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CbBattleMiddleWaitingPlayerComponent {
  particlesOptions: ISourceOptions = {
    fullScreen: { enable: false },
    particles: {
      number: {
        value: 20,
      },
      color: {
        value: ['#ffffff'],
      },
      move: {
        direction: 'none',
        enable: true,
        outModes: {
          default: 'out',
        },
        random: true,
        speed: 1.5,
        straight: false,
      },
      opacity: {
        value: { min: 0.17, max: 0.5 },
      },
      size: {
        value: { min: 1, max: 1.2 },
      },
      wobble: {
        enable: false,
      },
    },
  };

  private ngParticlesService = inject(NgParticlesService);
  private caseBattlesService = inject(CaseBattlesService);
  public sessionService = inject(SessionService);

  battle = input.required<ICaseBattle>();
  slot = input.required<number>();
  balance = input.required<BalanceType>();
  player = computed(() => {
    return (
      this.battle().participants.find((p) => p.slot === this.slot()) ?? null
    );
  });

  isHost = computed(
    () => this.sessionService.profile()?.steamid === this.battle().host
  );

  ngOnInit() {
    this.ngParticlesService.init(async (engine: Engine) => {
      await loadSlim(engine);
    });
  }

  public async handleJoinBattle() {
    this.caseBattlesService.joinBattle({
      uid: this.battle().uid,
      slot: this.slot() as CaseBattlesSlotsVariants,
    });
  }
  public async handleCallBots() {
    this.caseBattlesService.callBots(this.battle().uid);
  }
}
